import { render, staticRenderFns } from "./RelatedProductsBlockPDP.vue?vue&type=template&id=2406e13a&scoped=true&"
import script from "./RelatedProductsBlockPDP.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsBlockPDP.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductsBlockPDP.vue?vue&type=style&index=0&id=2406e13a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406e13a",
  null
  
)

export default component.exports